export default __webpack_public_path__ + "static/media/14_HighPower.4b98a1b1.png";